import { Link } from "react-router-dom";
import cssStyles from "src/styles/_error.module.css";
import Logo from "src/assets/images/logo.png";

// 404 안내 페이지 정의
const PageNotFound = ({message = "This page could not be found."}: { message?: string;}) => {

  // 페이지 렌더링
  return (
    <div id="__next">
      <div className={cssStyles["css-1i1mpo0"]}>
        <div
          style={{
            fontFamily:
              "-apple-system, BlinkMacSystemFont, Roboto, 'Segoe UI', 'Fira Sans', Avenir, 'Helvetica Neue', 'Lucida Grande', sans-serif",
            height: "100vh",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div>
            <Link to="/">
              <img src={Logo} alt="logo" height={80} />
            </Link>
          </div>
          <div>
            <h1
              className={cssStyles["next-error-h1"]}
              style={{
                display: "inline-block",
                margin: 0,
                marginRight: "20px",
                padding: "10px 23px 10px 0",
                fontSize: "24px",
                fontWeight: 500,
                verticalAlign: "top",
              }}
            >
              404
            </h1>
            <div
              style={{
                display: "inline-block",
                textAlign: "left",
                lineHeight: "49px",
                height: "49px",
                verticalAlign: "middle",
              }}
            >
              <h2
                style={{
                  fontSize: "14px",
                  fontWeight: "normal",
                  lineHeight: "inherit",
                  margin: 0,
                  padding: 0,
                }}
              >
                {message}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
